var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"dashboard-app"}},[_c('AppBar'),_c('Drawer'),_c('v-content',[_c('router-view')],1),_c('AppSnackbar'),_c('AppConfirm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }